// This function retrieves the value of a cookie by domain
const getCookie = (name) => {
    let cookie = document.cookie.split("; ");
    const appToken = cookie.find((item) => item.includes(name));
    return appToken ? appToken.split("=")[1] : null;
};

// This function retrieves the value of a cookie by shop id
const getCookieByShopId = (name, shop_id) => {
    const cookie = getCookie(name);
    if (cookie) {
        try {
            const cookieObj = JSON.parse(cookie);
            return cookieObj[shop_id]
        } catch (error) {
            return null
        }
    }
};

export {
    getCookie,
    getCookieByShopId
};
